import React from "react";
import { useContext } from "react";
import "./Sidebar.css";
import { SidebarContext } from "../Context/SidebarContext";

export default function Sidebar() {
  const { dispatch, state } = useContext(SidebarContext);

  return (
    <>
      <div className={`sidebar-sec  ${!state.enabled ? "side-bar-off" : ""}`}>
        <div className="container-1280">
          <div className="row">
            <div className="col-lg-12 side-img">
              <img
                src={require("./../../Assets/img/arrow.png")}
                onClick={() => {
                  dispatch({ type: "TOGGLE", data: false });
                }}
                alt="arrow"
              />
              <div className="search-bar">
                <form className="example" action="/action_page.php">
                  <input
                    type="text"
                    placeholder="What are you playing today?"
                    name="search"
                  />
                  <button type="button">
                    <i className="fa fa-search"></i>
                  </button>
                </form>
              </div>
            </div>
          </div>
          <div className="row tags-row">
            <div className="col-lg-3">
              <h4>Shooting Game</h4>
            </div>
            <div className="col-lg-3">
              <h4>Racing Game</h4>
            </div>
            <div className="col-lg-3">
              <h4>Strategy Game</h4>
            </div>
            <div className="col-lg-3">
              <h4>Games for boys</h4>
            </div>
          </div>
          <div className="row popular-games">
            <div className="col-lg-12">
              <h1>Popular this week</h1>
            </div>
            <div className="col-lg-3 game-card">
              <img src={require("./../../Assets/img/pop1.png")} alt="pop1" />
            </div>
            <div className="col-lg-3 game-card">
              <img src={require("./../../Assets/img/pop2.png")} alt="pop2" />
            </div>
            <div className="col-lg-3 game-card">
              <img src={require("./../../Assets/img/pop3.png")} alt="pop3" />
            </div>
            <div className="col-lg-3 game-card">
              <img src={require("./../../Assets/img/pop4.png")} alt="pop4" />
            </div>
          </div>
          <div className="row recently-played">
            <div className="col-lg-12">
              <h1>Recently Played</h1>
            </div>
            <div className="col-lg-3">
              <img
                src={require("./../../Assets/img/recentgame.png")}
                alt="recentgame"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
